






























































































import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { DataTablePagination } from '@/types/_'
import { maskMoney } from '@/utils/common'

@Component
export default class FinanceiroTabelaRegrasGarantiaMinima extends Vue {
  deleteRegraDeCalculo: boolean = false
  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get regrasDeCalculo() { return this.getRegrasDeCalculoStore.regrasGarantiaMinima }

  loadRegrasDeCalculo: boolean = false
  get loadingRegrasDeCalculo() { return this.loadRegrasDeCalculo }
  set loadingRegrasDeCalculo(value: boolean) { this.loadRegrasDeCalculo = value }

  get showModalRegraGarantiaMinima() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoGarantiaMinima }
  set showModalRegraGarantiaMinima(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoGarantiaMinima', value }) }

  get showModalDelete() { return this.deleteRegraDeCalculo }
  set showModalDelete(value: boolean) { this.deleteRegraDeCalculo = value }

  get paginacaoRegrasDeCalculo() { return this.getRegrasDeCalculoStore.paginacaoGarantiaMinima }

  headers = [
    { text: 'Fonte Pagadora', value: 'nomeFontePagadoraDestino', sortable: false },
    { text: 'Prestador', value: 'razaoSocialPrestador', sortable: false },
    { text: 'Valor garantia', value: 'valorGarantiaMinima', sortable: false },
    { text: 'Grupo Repasse', value: 'nomeGrupoRepasseDestino', sortable: false },
    { text: 'Descrição', value: 'descricaoRegra', sortable: false },
    { text: 'Inicio vigência', value: 'inicioVigencia', sortable: false },
    { text: 'Fim vigência', value: 'fimVigencia', sortable: false },
    { text: 'Ações', value: '', align: 'center', sortable: false },
  ]

  loadingEditarRegraDeCalculo: string = ''
  loadingDeleteCalculo: boolean = false

  displayDate(value: any) {
    if (!value) return ' - '
    return moment(value).format('DD/MM/YYYY')
  }

  formatMoneyUtil(value: any) {
    return maskMoney(value)
  }

  openModalDelete(id: string) {
    this.getRegrasDeCalculoStore.setRegraDeCalculoIdGarantiaMinima(id)
    this.showModalDelete = true
  }

  async editarRegraGarantiaMinima(item: any) {
    this.loadingEditarRegraDeCalculo = item.id
    this.getRegrasDeCalculoStore.setModeModalGarantiaMinima('EDIT')
    this.getRegrasDeCalculoStore.setRegraGarantiaMinimaItem(item)
    this.getRegrasDeCalculoStore.setRegraDeCalculoIdGarantiaMinima(item.id)
    await this.getRegrasDeCalculoStore.getHospitaisGarantiaMinimaGlobal(item.id)
    this.showModalRegraGarantiaMinima = true
    this.loadingEditarRegraDeCalculo = ''
  }

  async deleteRegraGarantiaMinima() {
    this.loadingDeleteCalculo = true
    const request = await this.getRegrasDeCalculoStore.deleteRegraGarantiaMinima()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDeleteCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: 'Regra de cálculo excluída com sucesso!',
      icon: 'check',
      color: '#43A047',
    })
    this.showModalDelete = false
    this.loadingDeleteCalculo = false
  }

  regrasDeCalculoDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getRegrasGarantiaMinima(param), 700)

  async updatePaginationRegrasDeCalculo(pagination: DataTablePagination) {
    this.loadingRegrasDeCalculo = true
    this.regrasDeCalculoDebounced(pagination)
    this.loadingRegrasDeCalculo = false
  }

  beforeDestroy() {
    this.getRegrasDeCalculoStore.clearRegrasDeCalculo()
    this.getRegrasDeCalculoStore.clearRegraDeCalculo()
    this.getRegrasDeCalculoStore.clearTabelasPreco()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoContratos()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoOperadoras()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoProcedimentosDescartar()
  }
}
